// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap);"]);
// Module
exports.push([module.id, ".C-more-news[data-v-0ad8bebb]{display:flex;justify-content:center;align-items:center;margin:0 auto;margin-bottom:20px}.rinkimai2023[data-v-0ad8bebb]{height:736px}@media(max-width:575.98px){.rinkimai2023[data-v-0ad8bebb]{height:1000px}}", ""]);
// Exports
module.exports = exports;
